import { render, staticRenderFns } from "./template_edit.vue?vue&type=template&id=882156e2&scoped=true"
import script from "./template_edit.vue?vue&type=script&lang=js"
export * from "./template_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882156e2",
  null
  
)

export default component.exports